import { render, staticRenderFns } from "./DashboardNewBuild.vue?vue&type=template&id=6951fe47&scoped=true&"
import script from "./DashboardNewBuild.vue?vue&type=script&lang=js&"
export * from "./DashboardNewBuild.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNewBuild.vue?vue&type=style&index=0&id=6951fe47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951fe47",
  null
  
)

export default component.exports